

document.addEventListener("DOMContentLoaded", function () {

    const products = {
        "ACV Reset": ["1 Tube","2 Tubes","4 Tubes"],
        "Calm Energy": ["1 Canister","2 Canisters","4 Canisters"],
        "Gentle Sleep": ["1 Canister","2 Canisters","4 Canisters"],
        "Gut Comfort": ["1 Canister","2 Canisters","4 Canisters"],
        "Metabolic Balance": ["1 Canister","2 Canisters","4 Canisters"],
        "Skin Radiance": ["1 Canister","2 Canisters","4 Canisters"]
    };

    const product = document.getElementById("product-select");
    const variant = document.getElementById("variant-select");
    const qty = document.querySelector('input[name="contact[Quantity]"]');

    if (!product || !variant) return;

    function loadVariants(productName, selectedVariant = "") {
        // Update Preview Cards
if (previewProduct) {
    previewProduct.textContent = decodeURIComponent(urlProduct);
}

if (previewVariant) {
    previewVariant.textContent = decodeURIComponent(urlVariant || "");
}

        variant.innerHTML = '<option value="">Select Variant</option>';

        if (!products[productName]) return;

        products[productName].forEach(function(item){

            let op = document.createElement("option");

            op.value = item;
            op.textContent = item;

            if(item === selectedVariant){
                op.selected = true;
            }

            variant.appendChild(op);

        });

    }

    product.addEventListener("change", function(){

        loadVariants(this.value);

    });

    const params = new URLSearchParams(window.location.search);

    const urlProduct = params.get("product");
    const urlVariant = params.get("variant");
    const urlQty = params.get("qty");

    if(urlProduct){

        product.value = decodeURIComponent(urlProduct);

        loadVariants(
            decodeURIComponent(urlProduct),
            decodeURIComponent(urlVariant || "")
        );

    }

    if(urlQty && qty){

        qty.value = urlQty;

    }

});

// Preview Cards

const previewProduct = document.getElementById("product-preview");
const previewVariant = document.getElementById("variant-preview");
const previewQty = document.getElementById("qty-preview");

if(previewProduct){
    previewProduct.innerHTML = product.value;
}

if(previewVariant){
    previewVariant.innerHTML = variant.value;
}

if(previewQty){
    previewQty.innerHTML = qty.value;
}

variant.addEventListener("change",function(){

    previewVariant.innerHTML=this.value;

});

qty.addEventListener("input",function(){

    previewQty.innerHTML=this.value;

});





